var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetFoodContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.959,
    height: 32,
    viewBox: "0 0 25.959 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "pet-food-paw-svgrepo-com",
    transform: "translate(-48.328 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(48.328 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M74.26,12.231,70.979,2.7V.491a.492.492,0,0,0-.624-.474L68.2.621l-2.165-.6a.492.492,0,0,0-.264,0L63.6.621l-2.165-.6a.492.492,0,0,0-.264,0l-2.165.6-2.165-.6a.492.492,0,0,0-.264,0l-2.165.6-2.1-.586A.49.49,0,0,0,52.127,0h-.011a.492.492,0,0,0-.481.594V2.7l-3.281,9.533a.492.492,0,0,0-.027.16V22.2a.492.492,0,1,0,.983,0V12.473l3.167-9.2h13.9a.492.492,0,0,0,0-.983H52.619V1.142l1.663.464a.492.492,0,0,0,.264,0L56.711,1l2.165.6a.492.492,0,0,0,.264,0L61.305,1l2.165.6a.492.492,0,0,0,.264,0L65.9,1l2.165.6a.492.492,0,0,0,.264,0L70,1.139V2.287h-2.01a.492.492,0,0,0,0,.983H69.8l-3.084,8.96a.492.492,0,0,0-.027.16V31.016H49.311V23.809a.492.492,0,1,0-.983,0v7.7A.492.492,0,0,0,48.82,32H67.18l.048,0,.023,0,.024,0,.028-.007.018,0,.029-.01.013,0,.008,0h0l6.607-2.651a.492.492,0,0,0,.309-.456V12.391A.5.5,0,0,0,74.26,12.231ZM73.3,28.521l-5.632,2.26V12.473L70.487,4.29,73.3,12.473V28.521Z",
    transform: "translate(-48.328 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(53.174 20.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M131.491,331.482l-.02-.021a2.594,2.594,0,0,0-1.881-.645,4.722,4.722,0,0,0-3.493,1.425,1.132,1.132,0,0,0-.174,1.054,2.615,2.615,0,0,0,1.176,1.353,3.524,3.524,0,0,1,1.2,1.2,2.615,2.615,0,0,0,1.353,1.176,1.038,1.038,0,0,0,.356.063h0c.644,0,1.26-.6,1.691-1.636C132.231,334.172,132.391,332.381,131.491,331.482Zm-.7,3.6c-.319.77-.671,1.029-.782,1.029a.054.054,0,0,1-.02,0,1.661,1.661,0,0,1-.844-.755A4.506,4.506,0,0,0,127.6,333.8a1.661,1.661,0,0,1-.755-.844c-.015-.042.028-.114.056-.154a3.9,3.9,0,0,1,2.687-1.006,1.688,1.688,0,0,1,1.189.359l.014.014C131.324,332.705,131.21,334.068,130.791,335.077Z",
    transform: "translate(-125.86 -330.817)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(57.037 15.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M190.515,251.942a2.042,2.042,0,0,0-2.635,1.186c-.374.986-.344,3.153.822,3.6a1.179,1.179,0,0,0,.42.075h0c1.124,0,2.293-1.468,2.579-2.222A2.046,2.046,0,0,0,190.515,251.942Zm.267,2.287c-.238.627-1.169,1.588-1.66,1.587a.2.2,0,0,1-.072-.011c-.38-.144-.535-1.58-.251-2.328a1.066,1.066,0,0,1,.992-.685,1.061,1.061,0,0,1,.991,1.436Z",
    transform: "translate(-187.667 -251.809)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(52.991 16.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M126.537,262.507a1.821,1.821,0,1,0-3.569.721c.164.813,1.09,2.307,2.11,2.307h0a1.062,1.062,0,0,0,.209-.021C126.376,265.295,126.72,263.416,126.537,262.507Zm-1.445,2.043h-.014c-.33,0-1.026-.922-1.146-1.518a.837.837,0,0,1,.655-.986.836.836,0,0,1,.986.655C125.706,263.362,125.367,264.5,125.092,264.551Z",
    transform: "translate(-122.931 -261.047)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(59.394 18.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M230.243,304a2.042,2.042,0,0,0-2.635-1.186,4.374,4.374,0,0,0-1.538,1.129,1.9,1.9,0,0,0-.609,1.87c.352.929,1.7,1.029,2.258,1.029a3.975,3.975,0,0,0,1.338-.207A2.046,2.046,0,0,0,230.243,304Zm-1.535,1.716a3.071,3.071,0,0,1-.989.143c-.744,0-1.265-.2-1.339-.395-.05-.132.061-.46.424-.868a3.4,3.4,0,0,1,1.152-.863,1.06,1.06,0,1,1,.752,1.983Z",
    transform: "translate(-225.386 -302.682)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(59.318 23.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M227.2,375.716a2.635,2.635,0,0,0-.517-.046c-.9,0-2.3.345-2.49,1.3a1.689,1.689,0,0,0,.8,1.565,3.821,3.821,0,0,0,1.487.755,1.821,1.821,0,1,0,.721-3.569Zm.46,1.95a.836.836,0,0,1-.986.655,2.887,2.887,0,0,1-1.063-.555c-.361-.292-.47-.527-.454-.606.04-.2.754-.507,1.526-.507a1.657,1.657,0,0,1,.322.027A.838.838,0,0,1,227.659,377.666Z",
    transform: "translate(-224.171 -375.67)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetFoodContainer);
export default __webpack_public_path__ + "static/media/petFoodContainer.261d170ffe4cec74b52215e1682a483c.svg";
export { ForwardRef as ReactComponent };